function getParentElement(elm, parentData) {
  let validParent = null;
  if (!elm) {
    return null;
  }
  const {
    parentClass,
    parentId,
    parentTag
  } = parentData;
  let parent = elm;
  while (parent && parent.tagName.toLowerCase() !== "body") {
    if (parentId && parentId.toLowerCase() === (parent == null ? void 0 : parent.id.toLowerCase()) || parentClass && (parent == null ? void 0 : parent.classList.contains(parentClass)) || parentTag && parentTag.toLowerCase() === (parent == null ? void 0 : parent.tagName.toLowerCase())) {
      validParent = parent;
      break;
    }
    parent = parent.parentElement;
  }
  return validParent;
}
export {
  getParentElement
};
//# sourceMappingURL=dom.mjs.map
